import { render, staticRenderFns } from "./AssetTypeEditForm.vue?vue&type=template&id=d5c73f84&scoped=true"
import script from "./AssetTypeEditForm.vue?vue&type=script&lang=js"
export * from "./AssetTypeEditForm.vue?vue&type=script&lang=js"
import style0 from "./AssetTypeEditForm.vue?vue&type=style&index=0&id=d5c73f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c73f84",
  null
  
)

export default component.exports